(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bespoke-home-signage"]) return;
  try {
    
document.querySelectorAll('[data-bespoke-choice]').forEach(link=>link.addEventListener('click',()=>{const select=document.querySelector('[data-bespoke-select]');if(select)select.value=link.dataset.bespokeChoice;}));
const bespokeSuccess=document.querySelector('.bh__success');if(bespokeSuccess){bespokeSuccess.scrollIntoView({block:'center'});bespokeSuccess.focus();}
function initBespokeMotion(root){
  root.querySelectorAll('[data-bespoke-motion]').forEach(box=>{
    if(box.dataset.initialized)return;
    box.dataset.initialized='true';
    const video=box.querySelector('video'),button=box.querySelector('button');
    if(!video||!button)return;
    const preference=window.matchMedia('(prefers-reduced-motion: reduce)');
    let wantsPlayback=!preference.matches;
    button.hidden=false;
    function load(){const source=video.querySelector('source');if(!source.src){source.src=source.dataset.src;video.load();}}
    function play(){load();video.muted=true;video.play().catch(()=>{button.textContent=button.dataset.play;});}
    video.addEventListener('playing',()=>{box.classList.add('is-ready','is-playing');button.textContent=button.dataset.pause;});
    video.addEventListener('pause',()=>{box.classList.remove('is-playing');button.textContent=button.dataset.play;});
    video.addEventListener('error',()=>{box.classList.remove('is-ready','is-playing');button.hidden=true;});
    button.addEventListener('click',()=>{wantsPlayback=video.paused;if(wantsPlayback)play();else video.pause();});
    preference.addEventListener('change',e=>{wantsPlayback=!e.matches;if(e.matches)video.pause();else play();});
    document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();else if(wantsPlayback)play();});
    if(wantsPlayback)play();
  });
}
initBespokeMotion(document);
document.addEventListener('shopify:section:load',e=>initBespokeMotion(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bin-sign-product"]) return;
  try {
    
if(!customElements.get('bin-sign-order'))customElements.define('bin-sign-order',class extends HTMLElement{
 connectedCallback(){if(this.started)return;this.started=true;this.form=this.querySelector('form');this.qty=this.querySelector('[name="quantity"]');this.button=this.querySelector('[type="submit"]');this.words=JSON.parse(this.querySelector('[data-bs-strings]').textContent);this.busy=false;this.form.addEventListener('change',()=>this.paint());this.qty.addEventListener('input',()=>this.paint());this.form.addEventListener('submit',e=>this.add(e));this.paint();}
 money(cents){return new Intl.NumberFormat('en-AU',{style:'currency',currency:this.dataset.currency||'AUD'}).format(cents/100);}
 paint(){const v=this.querySelector('[name="id"]:checked');if(!v)return;const n=Number(this.qty.value),valid=Number.isInteger(n)&&n>0;this.querySelectorAll('[data-bs-image]').forEach(el=>el.hidden=el.dataset.bsImage!==v.value);this.querySelector('[data-bs-summary]').textContent=v.dataset.title+' · 200 × 260 mm';this.querySelector('[data-bs-total]').textContent=valid?this.money(Number(v.dataset.price)*n):'—';this.querySelector('[data-bs-inclusive]').textContent=valid?this.money(Math.round(Number(v.dataset.price)*n*1.1))+' '+this.words.inc:'';this.button.disabled=this.busy||!valid||v.dataset.available!=='true';this.button.textContent=this.busy?this.words.adding:v.dataset.available==='true'?this.words.add:this.words.sold;const u=new URL(location.href);u.searchParams.set('variant',v.value);history.replaceState({},'',u);}
 async add(e){
  e.preventDefault();
  if(this.busy||!this.form.reportValidity())return;
  const v=this.querySelector('[name="id"]:checked');
  if(!v||v.dataset.available!=='true')return;
  const error=this.querySelector('[data-bs-error]');
  const cart=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
  const quantity=Number(this.qty.value);
  error.hidden=true;this.busy=true;this.paint();
  try{
   const body=new FormData();
   body.append('id',v.value);body.append('quantity',String(quantity));
   if(cart&&typeof cart.getSectionsToRender==='function'){
    body.append('sections',cart.getSectionsToRender().map(section=>section.id).join(','));
    body.append('sections_url',window.location.pathname);
    cart.setActiveElement(this.button);
   }
   const r=await fetch(this.dataset.add+'.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body});
   const data=await r.json();
   if(!r.ok||data.status)throw Error(data.description||this.words.error);
   if(!cart||typeof cart.renderContents!=='function'){location.assign(this.dataset.cart);return;}
   const render=()=>{
    try{cart.classList.remove('is-empty');cart.renderContents(data);}
    catch(renderError){location.assign(this.dataset.cart);}
   };
   const modal=this.closest('quick-add-modal');
   if(modal){
    document.body.addEventListener('modalClosed',()=>setTimeout(render),{once:true});
    modal.hide(true);
   }else{render();}
  }catch(err){error.textContent=err.message||this.words.error;error.hidden=false;}
  finally{this.busy=false;this.paint();}
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-sign-product"]) return;
  try {
    
if(!customElements.get('home-sign-order'))customElements.define('home-sign-order',class extends HTMLElement{
 connectedCallback(){if(this.started)return;this.started=true;this.form=this.querySelector('form');this.qty=this.querySelector('[name="quantity"]');this.button=this.querySelector('[type="submit"]');this.words=JSON.parse(this.querySelector('[data-hp-strings]').textContent);this.variants=JSON.parse(this.querySelector('[data-hp-variants]').textContent);this.taxFactor=this.dataset.taxIncluded==='true'?1:1.1;this.querySelectorAll('[data-hp-personal]').forEach(el=>el.addEventListener('input',()=>this.paint()));this.busy=false;this.form.addEventListener('change',()=>this.paint());this.qty.addEventListener('input',()=>this.paint());this.form.addEventListener('submit',e=>this.add(e));this.paint();}
 money(cents){return new Intl.NumberFormat('en-AU',{style:'currency',currency:this.dataset.currency||'AUD'}).format(cents/100);}
 selectedVariant(){return this.variants.find(v=>v.option1===this.querySelector('[name="sign_size"]:checked')?.value&&v.option2===this.querySelector('[name="sign_material"]:checked')?.value);}
 paint(){
  const v=this.selectedVariant();if(!v)return;
  this.querySelector('input[name="id"]').value=v.id;this.querySelector('input[name="id"]').disabled=false;
  const n=Number(this.qty.value),valid=Number.isInteger(n)&&n>0;
  this.querySelectorAll('[data-hp-image]').forEach(el=>el.hidden=el.dataset.hpImage!==String(v.id));
  this.querySelector('[data-hp-size]').textContent=v.option1;
  this.querySelector('[data-hp-summary]').textContent=v.title;
  this.querySelector('[data-hp-total]').textContent=valid?this.money(Math.round(v.price*n*this.taxFactor)):'—';
  this.querySelector('[data-hp-inclusive]').textContent=valid?this.money(this.dataset.taxIncluded==='true'?Math.round(v.price*n/1.1):v.price*n)+' '+this.words.ex:'';
  this.querySelectorAll('[data-hp-option-price]').forEach(el=>{const choice=this.variants.find(x=>x.option1===v.option1&&x.option2===el.dataset.hpOptionPrice);el.textContent=choice?this.money(Math.round(choice.price*this.taxFactor))+' '+this.words.inc:'';});
  this.button.disabled=this.busy||!valid||!v.available;
  this.button.textContent=this.busy?this.words.adding:v.available?this.words.add:this.words.sold;
  const ps=this.querySelector('[data-hp-personal-summary]');if(ps)ps.textContent=Array.from(this.querySelectorAll('[data-hp-personal]')).map(el=>el.value.trim()).filter(Boolean).join(' · ');
  const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);
 }
 async add(e){
  e.preventDefault();
  if(this.busy||!this.form.reportValidity())return;
  const v=this.selectedVariant();
  if(!v||!v.available)return;
  const error=this.querySelector('[data-hp-error]');
  const cart=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
  const quantity=Number(this.qty.value);
  error.hidden=true;this.busy=true;this.paint();
  try{
   const body=new FormData(this.form);
   body.set('id',String(v.id));body.set('quantity',String(quantity));body.delete('sign_size');body.delete('sign_material');
   if(cart&&typeof cart.getSectionsToRender==='function'){
    body.append('sections',cart.getSectionsToRender().map(section=>section.id).join(','));
    body.append('sections_url',window.location.pathname);
    cart.setActiveElement(this.button);
   }
   const r=await fetch(this.dataset.add+'.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body});
   const data=await r.json();
   if(!r.ok||data.status)throw Error(data.description||this.words.error);
   if(!cart||typeof cart.renderContents!=='function'){location.assign(this.dataset.cart);return;}
   const render=()=>{
    try{cart.classList.remove('is-empty');cart.renderContents(data);}
    catch(renderError){location.assign(this.dataset.cart);}
   };
   const modal=this.closest('quick-add-modal');
   if(modal){
    document.body.addEventListener('modalClosed',()=>setTimeout(render),{once:true});
    modal.hide(true);
   }else{render();}
  }catch(err){error.textContent=err.message||this.words.error;error.hidden=false;}
  finally{this.busy=false;this.paint();}
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      if(document.getElementById('SortBy')){
        document.getElementById('SortBy').value = event.target.dataset.value;
        document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
      }
      else{
        document.getElementById('SortBy-mobile').value = event.target.dataset.value;
        document.getElementById('FacetFiltersFormMobile').dispatchEvent(new Event('input'));
      }
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-fire-door-tags"]) return;
  try {
    
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    }

    if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    }

    if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      document.getElementById('SortBy').value = event.target.dataset.value;
      document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["standard-sign-product"]) return;
  try {
    
if(!customElements.get('standard-sign-order'))customElements.define('standard-sign-order',class extends HTMLElement{
 connectedCallback(){if(this.started)return;this.started=true;this.form=this.querySelector('form');this.qty=this.querySelector('[name="quantity"]');this.button=this.querySelector('[type="submit"]');this.words=JSON.parse(this.querySelector('[data-ss-strings]').textContent);this.variants=JSON.parse(this.querySelector('[data-ss-variants]').textContent);this.busy=false;this.form.addEventListener('change',()=>this.paint());this.qty.addEventListener('input',()=>this.paint());this.form.addEventListener('submit',e=>this.add(e));this.paint();}
 money(cents){return new Intl.NumberFormat('en-AU',{style:'currency',currency:this.dataset.currency||'AUD'}).format(cents/100);}
 selectedVariant(){return this.variants.find(v=>v.option1===this.querySelector('[name="sign_size"]:checked')?.value&&v.option2===this.querySelector('[name="sign_material"]:checked')?.value);}
 paint(){
  const v=this.selectedVariant();if(!v)return;
  this.querySelector('input[name="id"]').value=v.id;this.querySelector('input[name="id"]').disabled=false;
  const n=Number(this.qty.value),valid=Number.isInteger(n)&&n>0;
  this.querySelectorAll('[data-ss-image]').forEach(el=>el.hidden=el.dataset.ssImage!==String(v.id));
  this.querySelector('[data-ss-size]').textContent=v.option1;
  this.querySelector('[data-ss-summary]').textContent=v.title;
  this.querySelector('[data-ss-total]').textContent=valid?this.money(v.price*n):'—';
  this.querySelector('[data-ss-inclusive]').textContent=valid?this.money(Math.round(v.price*n*1.1))+' '+this.words.inc:'';
  this.querySelectorAll('[data-ss-option-price]').forEach(el=>{const choice=this.variants.find(x=>x.option1===v.option1&&x.option2===el.dataset.ssOptionPrice);el.textContent=choice?this.money(choice.price)+' '+this.words.ex:'';});
  this.button.disabled=this.busy||!valid||!v.available;
  this.button.textContent=this.busy?this.words.adding:v.available?this.words.add:this.words.sold;
  const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);
 }
 async add(e){
  e.preventDefault();
  if(this.busy||!this.form.reportValidity())return;
  const v=this.selectedVariant();
  if(!v||!v.available)return;
  const error=this.querySelector('[data-ss-error]');
  const cart=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
  const quantity=Number(this.qty.value);
  error.hidden=true;this.busy=true;this.paint();
  try{
   const body=new FormData();
   body.append('id',String(v.id));body.append('quantity',String(quantity));
   if(cart&&typeof cart.getSectionsToRender==='function'){
    body.append('sections',cart.getSectionsToRender().map(section=>section.id).join(','));
    body.append('sections_url',window.location.pathname);
    cart.setActiveElement(this.button);
   }
   const r=await fetch(this.dataset.add+'.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body});
   const data=await r.json();
   if(!r.ok||data.status)throw Error(data.description||this.words.error);
   if(!cart||typeof cart.renderContents!=='function'){location.assign(this.dataset.cart);return;}
   const render=()=>{
    try{cart.classList.remove('is-empty');cart.renderContents(data);}
    catch(renderError){location.assign(this.dataset.cart);}
   };
   const modal=this.closest('quick-add-modal');
   if(modal){
    document.body.addEventListener('modalClosed',()=>setTimeout(render),{once:true});
    modal.hide(true);
   }else{render();}
  }catch(err){error.textContent=err.message||this.words.error;error.hidden=false;}
  finally{this.busy=false;this.paint();}
 }
});

  } catch(e) { console.error(e); }
})();
})();
